import {
  SizeSelection,
  SizeSelection_Size,
  SizeSelection_SizeRuns,
  SizeSelection_Sizes,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/size_selection.types';

export const getSizeFinderRecommendations = (sizeSelection: SizeSelection) => {
  return (selectedSizeId: number) => {
    switch (sizeSelection.type?.$case) {
      case 'groupedSizes': {
        const groupedSizes = sizeSelection.type?.groupedSizes.groups[0];

        switch (groupedSizes?.content?.$case) {
          case 'sizeRuns': {
            return getSizeRunsString(
              groupedSizes.content.sizeRuns,
              selectedSizeId,
            );
          }

          case 'sizes': {
            return getSizesString(groupedSizes.content.sizes, selectedSizeId);
          }

          default:
            return undefined;
        }
      }

      case 'inlineSelection':
        return getSizeFinderString(
          sizeSelection.type.inlineSelection.sizes.find(
            size => size.sizeId === selectedSizeId,
          ),
        );

      case 'oneSize':
        return getSizeFinderString(sizeSelection.type.oneSize.size);

      case 'sizeRuns':
        return getSizeRunsString(sizeSelection.type.sizeRuns, selectedSizeId);

      case 'sizes':
        return getSizesString(sizeSelection.type.sizes, selectedSizeId);

      default:
        return undefined;
    }
  };
};

const getSizeRunsString = (
  sizeRuns: SizeSelection_SizeRuns,
  selectedSizeId: number,
) =>
  getSizeFinderString(
    sizeRuns.sizeRuns[0]?.sizes.find(size => size.sizeId === selectedSizeId),
  );

const getSizesString = (sizes: SizeSelection_Sizes, selectedSizeId: number) =>
  getSizeFinderString(sizes.sizes.find(size => size.sizeId === selectedSizeId));

const getSizeFinderString = (size: SizeSelection_Size | undefined) => {
  if (!size?.sizeTracker?.fitScore) {
    return undefined;
  }

  return `${size.sizeId}:${size.sizeTracker.fitScore}`;
};
